/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react'
import { TopicCard } from '../modules/topics/TopicCard'

const TopicPage: FC = () => (
  <>
    {/* begin::Row */}
    <div className='row gy-5 g-xl-12'>
      <div className='col-xxl-12'>
        <TopicCard />
      </div>
    </div>
    {/* end::Row */}
  </>
)

const TopicWrapper: FC = () => {
  return (
    <>
      <TopicPage />
    </>
  )
}

export { TopicWrapper }

